<template>
  <div>
    <CRow>
      <CCol col="12">
        <userList />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import userList from "../../components/supervisor/userList";

export default {
  name: "User_List",
  components: {
    userList,
  },
};
</script>

<style>
/* 📱 เฉพาะมือถือและแท็บเล็ต (< 992px) */
@media (max-width: 991.98px) {
  /* 1. บังคับเนื้อหาให้ชิดซ้ายสุด ไม่เว้นที่ให้ Sidebar */
  html:not([dir="rtl"]) .c-wrapper,
  html:not([dir="rtl"]) .c-main {
    margin-left: 0 !important;
    padding-left: 0 !important;
    transition: none !important;
  }
  
  /* 2. บังคับ Sidebar ให้ลอยทับเนื้อหา (Overlay) แทนการดัน */
  .c-sidebar {
    position: fixed !important;
    top: 66px !important; /* เว้นระยะ Header */
    left: 0;
    bottom: 0;
    z-index: 1030 !important;
    box-shadow: 2px 0 10px rgba(0,0,0,0.3) !important;
  }

  /* 3. ทำให้ฉากหลังสีดำ (Backdrop) ทำงานถูกต้อง */
  .c-sidebar-backdrop.c-show {
    opacity: 0.5 !important;
    z-index: 1020 !important;
  }
}

/* 💻 หน้าจอคอมพิวเตอร์ (>= 992px) ให้ทำงานปกติ */
@media (min-width: 992px) {
  html:not([dir="rtl"]) .c-wrapper {
    margin-left: 0; /* คืนค่าให้ CoreUI จัดการเอง */
  }
}
</style>